import { useNavigate } from 'react-router-dom'
import { useEffect } from 'react'
import { useAppDispatch } from '../../../shared/lib/hooks/useAppDispatch/useAppDispatch'
import { RoutePath } from '../../../shared/config/routeConfig/routeConfig'
import { Loader } from '../../../shared/ui/Loader/Loader'
import { fetchAuthUser } from '../model/services/fetchAuthUser'
import { useAppSelector } from '../../../shared/lib/hooks/useAppSelector/useAppSelector'
import { selectIsLoading } from '../selectors/selectIsLoading'
import { AppLink, AppLinkTheme } from '../../../shared/ui/AppLink/AppLink'
import { classNames } from '../../../shared/lib/classNames/classNames'
import classes from './AuthCallback.module.scss'
import { selectError } from '../selectors/selectError'

export function AuthCallback() {
	const dispatch = useAppDispatch()
	const navigate = useNavigate()
	const isLoading = useAppSelector(selectIsLoading)
	const error = useAppSelector(selectError)

	useEffect(() => {
		const getAuthUser = async () => {
			console.log('FETCH AUTH USER')
			const result = await dispatch(fetchAuthUser())
			if (result.meta.requestStatus === 'fulfilled') {
				navigate(RoutePath.profile)
			}
			if (result.meta.requestStatus === 'rejected') {
				navigate(RoutePath.login)
			}
		}

		getAuthUser().then(console.log).catch(console.error)
	}, [dispatch, navigate])

	return isLoading ? (
		<Loader />
	) : error ? (
		<div className={classNames(classes['auth-callback'], {}, [])}>
			<h5>{error}</h5>
			<AppLink
				to={RoutePath.login}
				theme={AppLinkTheme.STANDARD}
			>
				Log in again
			</AppLink>
		</div>
	) : ( // ui below is displayed for a fraction of second before auto reroute to profile page
		<div className={classNames(classes['auth-callback'], {}, [])}>
			<h5>Log in successful</h5>
			<AppLink
				to={RoutePath.profile}
				theme={AppLinkTheme.STANDARD}
			>
				Go to profile page
			</AppLink>
		</div>
	)
}